export default __webpack_public_path__ + "static/media/contacts-grey.7e695960.svg";